
import React from 'react'
import * as Yup from 'yup';
import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faEdit } from '@fortawesome/free-regular-svg-icons';
import { faAdd, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import CreatableSelect from "react-select/creatable";
import i18next from 'i18next';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import DataTable from "../../common/components/DataTable";
import { useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import { getDateFormat, getDateTimeFormat } from '../../../helpers/dateFormat';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { AESDecrypt, AESEncrypt } from '../../../encrypt-util';
import { updateDashbaordRefresh } from '../../common/components/DataTable/slices/DataTable';
import useDataCountry from '../../../hooks/useDataCountry';
import { AppDispatch, RootState } from '../../features/template/store';
import { useFieldArray, useFormContext } from "react-hook-form";

const ManualInvoiceDataTable = () => {
    const methods = useFormContext();
    const { fields, append, remove } = useFieldArray({
        control: methods.control,
        name: "manualInvoiceList",
    });

    console.log(methods.watch("manualInvoiceList"), 'manual invoice list data ')


    const staticHiddenCols = [];
    const uniqueFilterKey = "rowNumber";

    const manualInvoiceColumns = [

        {
            accessor: "invoiceNumber",
            Header: "Invoice Number",
            width: 250,
            maxWidth: 250,
            Cell: (rowData: any) => {
                const { docName, m, rowNumber, invoiceNumber } = rowData.row.original;
                const index = methods
                    .watch("manualInvoiceList")
                    .findIndex((row: any) => row.rowNumber === rowData.row.original.rowNumber);

                const onBlur = (e: any) => {
                    const cleanedValue = e.target.value.trim();
                    const invoiceNumberList = methods.watch("manualInvoiceList").map((row: any) => row.invoiceNumber);
                    if (invoiceNumberList.includes(cleanedValue) && cleanedValue.length > 0) {
                        methods.setError(`manualInvoiceList.${index}.invoiceNumber`, { message: "Invoice Number already exists" });
                    }
                    else if (cleanedValue.length > 0) {
                        methods.setValue(`manualInvoiceList.${index}.invoiceNumber`, cleanedValue, { shouldValidate: true });
                    }
                    else { return; }
                }
                console.log(methods.formState.errors, '<<errors')

                return (
                    <>
                        {m && <span className="mandatory">*</span>}

                        <Controller
                            name={`manualInvoiceList.${index}.invoiceNumber`}
                            control={methods.control}
                            render={({ field: { value }, fieldState: { error } }) => (
                                <Form.Control
                                    maxLength={50}
                                    className={`${error ? "is-invalid" : ""} form-control form-control-sm`}
                                    size='sm'
                                    defaultValue={methods.watch(`manualInvoiceList.${index}.invoiceNumber`) ?? ''}
                                    onBlur={onBlur}
                                />
                            )}
                        />
                    </>
                );

            },
        },

        {
            accessor: "blNumber",
            Header: "BL Number",
            width: 250,
            maxWidth: 250,
            Cell: (rowData: any) => {
                const { docName, m, rowNumber, invoiceNumber } = rowData.row.original;
                const index = methods
                    .watch("manualInvoiceList")
                    .findIndex((row: any) => row.rowNumber === rowData.row.original.rowNumber);

                return (
                    <>
                        {m && <span className="mandatory">*</span>}
                        {/*  <span title={container}>{container}</span> */}
                        <Controller
                            name={`manualInvoiceList.${index}.blNumber`}
                            control={methods.control}
                            render={({ field: { value }, fieldState: { error } }) => (
                                <Form.Control
                                    maxLength={50}
                                    className={`${error ? "is-invalid" : ""} form-control form-control-sm`}
                                    size='sm'
                                    defaultValue={value ?? ''}

                                    onBlur={(e) => {
                                        const cleanedValue = e.target.value.trim().toUpperCase();
                                        methods.setValue(`manualInvoiceList.${index}.blNumber`, cleanedValue);
                                    }}
                                    onChange={(e) => {
                                        e.target.value = e.target.value.toUpperCase()
                                    }}



                                />
                            )}
                        />
                    </>

                );
            },
        },
        {
            accessor: "invoiceAmount",
            Header: "Invoice Amount",
            width: 150,
            maxWidth: 250,
            Cell: (rowData: any) => {
                const { docName, m, rowNumber, invoiceNumber } = rowData.row.original;
                const index = methods
                    .watch("manualInvoiceList")
                    .findIndex((row: any) => row.rowNumber === rowData.row.original.rowNumber);

                return (
                    <>
                        {m && <span className="mandatory">*</span>}

                        <Controller
                            name={`manualInvoiceList.${index}.invoiceAmount`}
                            control={methods.control}
                            render={({ field: { value }, fieldState: { error } }) => (
                                <Form.Control
                                    maxLength={17}
                                    className={`${error ? "is-invalid" : ""} form-control form-control-sm`}
                                    size='sm'
                                    defaultValue={methods.watch(`manualInvoiceList.${index}.invoiceAmount`) ?? ''}
                                    onBlur={(e) => {
                                        // Allow negative values and fix multiple dots issue
                                        let inputValue = e.target.value.trim();
                                        // Remove all characters except digits, dot, and minus sign
                                        inputValue = inputValue.replace(/[^0-9.-]/g, '');
                                        // Only allow one minus at the start
                                        inputValue = inputValue.replace(/(?!^)-/g, '');
                                        // Only allow one dot
                                        inputValue = inputValue.replace(/\.(?=.*\.)/g, '');
                                        const trimmedValue = inputValue;
                                        methods.setValue(`manualInvoiceList.${index}.invoiceAmount`, trimmedValue);
                                    }}
                                />
                            )}
                        />
                    </>

                );
            },
        },
        {
            accessor: "invoiceDate",
            Header: "Invoice Date",
            width: 150,
            maxWidth: 200,
            Cell: (rowData: any) => {
                const { docName, m, rowNumber, invoiceNumber } = rowData.row.original;
                const index = methods
                    .watch("manualInvoiceList")
                    .findIndex((row: any) => row.rowNumber === rowData.row.original.rowNumber);

                return (


                    <>
                        <Controller
                            name={`manualInvoiceList.${index}.invoiceDate`}
                            control={methods.control}
                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                <DatePicker
                                    className={`${error ? "is-invalid" : ""} fs--2 form-control form-control-sm`}

                                    dateFormat={getDateFormat()}
                                    isClearable={true}
                                    popperProps={{
                                        strategy: 'fixed',
                                    }}


                                    selected={value}
                                    portalId="root-portal"
                                    value={methods.watch(`manualInvoiceList.${index}.invoiceDate`) ?? null}
                                    onChange={(e) => {

                                        methods.setValue(`manualInvoiceList.${index}.invoiceDate`, e);
                                    }}
                                />
                            )}
                        />

                    </>

                );
            },
        },
        {
            accessor: "delete",
            Header: "",
            width: 20,
            maxWidth: 20,
            Cell: (rowData: any) => {
                const index = methods
                    .watch("manualInvoiceList")
                    .findIndex((row: any) => row.rowNumber === rowData.row.original.rowNumber);

                return (
                    <Button
                        variant="falcon-warning"
                        onClick={() => {
                            if (methods.watch("manualInvoiceList").length === 1) {
                                methods.setValue(`manualInvoiceList.${index}.invoiceNumber`, "");
                                methods.setValue(`manualInvoiceList.${index}.blNumber`, "");
                                methods.setValue(`manualInvoiceList.${index}.invoiceAmount`, "");
                                methods.setValue(`manualInvoiceList.${index}.invoiceDate`, null);
                            } else {
                                remove(index);
                            }
                        }}
                        style={{
                            background: "transparent",
                            border: "none",
                            boxShadow: "none",
                            padding: "0px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size="sm" />
                    </Button>
                );
            },
        },
    ];

    return (
        <>

            <div>
                <button
                    type="button"
                    onClick={() => {
                        const rowNumber = crypto.randomUUID();
                        const formInvoiceDate = methods.watch('invoiceDate');
                        append({
                            rowNumber: rowNumber,
                            invoiceNumber: "",
                            invoiceDate: formInvoiceDate,
                            blNumber: "",
                        });
                    }}
                    className="btn-falcon-primary btn btn-primary btn-sm mb-3 mt-3"
                    style={{ width: "max-content" }}
                >
                    <FontAwesomeIcon className="me-1" icon={faAdd} /> Add Manual Invoice
                </button>
            </div>


            <DataTable
                columns={manualInvoiceColumns}
                gridName="BANKACCOUNT"
                data={methods.watch("manualInvoiceList")}
                pagination={false}
                selection={false}
                sortable={false}
                perPage={100}
                searchable={false}
                showExport={false}
                showColumnFilter={undefined}
                uniqueFilterKey={uniqueFilterKey}
                autoHeight={true}
                tableMinHeight={100}
            // staticHiddenCols={staticHiddenCols}
            />
        </>
    );
};

export default ManualInvoiceDataTable;
